module.exports = __webpack_public_path__ + "static/assets/dc366194fb79d8d3e6d19e353edfd07e.jpg";